<div class="body-container">
    <app-single-card class="app-card" [title]="title" [description]="description">
        <router-outlet></router-outlet>
    </app-single-card>
</div>
